// extracted by mini-css-extract-plugin
export default {"SanitizedHtml":"title-module__SanitizedHtml--GBgb9","Link":"title-module__Link--bfWqS","SanitizedHtml_1":"title-module__SanitizedHtml_1--dvKYp"};